import http from '../common/http';
import env from '../envConfig';
import { getHeader } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';

export const obterTiposLogradouro = async () => {
  const url = env.urlApi + `/transacional-api/v1/dominio/tipo-logradouro`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterTitulosLogradouro = async () => {
  const url = env.urlApi + `/transacional-api/v1/dominio/titulo-logradouro`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterPaises = async () => {
  const url = env.urlApi + `/transacional-api/v1/dominio/paises`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};
